import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { Tabs } from 'antd'

import Setting from "./setting/setting";
import Monitoring from "./monitoring/monitoring";
import ResearchCenter from "./researchCenter/researchCenter";
import Participants from "./participants/participants";
import GroupManage from "./groupManage/groupManage";
import RegionalManagement from "./regionalManagement/regionalManagement";
import ProjectSettlement from "./projectSettlement/projectSettlement";
import ProjectReport from "./projectReport/projectReport";

import {GetProjectDetailInfo} from "../../../services/project/ProjectService";
import { RouteChildrenProps } from 'react-router-dom';

import './index.less'
import modStyl from './index.module.scss'
import { DataBoardComponent } from '../../data/data-board';
import { readProjectCode, readProjectId, readRoleCode, writeProjectCode, writeProjectId } from '../../../utils/storage';

type State = {
  id: number
  code: string
  activeKey: string
}

const ProjectDetail: React.FC<RouteChildrenProps<any, State>> = (props)=> {

  const { history, location } = props

  //location.state.activeKey
  const [activeKey, setActiveKey] = useState(()=> location.state.activeKey || '1')
  const [hidden, setHidden] = useState(false)

  // const [status, setStatus] = useState('')
  const [data, setData] = useState<any>({})

  const projectId = useMemo(()=> location.state.id, [])
  const projectCode = useMemo(()=> location.state.code, [])
  const roleCode = useMemo(()=> readRoleCode(), [])

  const fetchDetail = async ()=> {

    const data = await GetProjectDetailInfo(projectId)

    // const transform = {
    //   PROCESS: '进行中',
    //   STOP: '已暂停',
    //   END: '已完成'
    // }

    // type K = keyof typeof transform

    // setStatus(transform[data.status as K] ?? '')
    setActiveKey(data.isJs === 1 ? '0' : '1')
    setData(data)
    writeProjectCode(data.code)
  }

  useEffect(()=> {
    if (location.state.id) {
      writeProjectId(location.state.id)
      writeProjectCode(location.state.code)
      fetchDetail()
    } else {
      history.push('/noConfigPage')
    }
  }, [])

  const handleChange = (key: string) => {
    setActiveKey(key)
    setHidden(['0', '1'].includes(key))
  }

  return (
    <div className={modStyl.wrapper}>
      <div className={modStyl.header}>
        <div className={modStyl.west}>{data.name}</div>
        <div className={modStyl.east} hidden={hidden}>
          <dl>
            <dt>截止日期：</dt>
            <dd>{data.endTimeVal}</dd>
          </dl>
          <dl>
            <dt>目标样本数：</dt>
            <dd>{data.groupGoal}</dd>
          </dl>
        </div>
      </div>
      <Tabs className="ant-tabs-override" defaultActiveKey='1' tabBarGutter={58} size='large' activeKey={activeKey} onChange={handleChange}>
        
        {
          data.isJs === 1 && (
            <Tabs.TabPane tab="数据看板" key="0">
              <DataBoardComponent mainTabIndex={activeKey} tableScrollY={window.innerHeight - 563} wrapperStyl={{padding: 0, height: 'calc(100vh - 257px)'}} projectId={projectId} projectCode={projectCode}/>
            </Tabs.TabPane>
          )
        }
        <Tabs.TabPane tab="项目监控" key="1">
          <Monitoring projectId={projectId}/>
        </Tabs.TabPane>
        <Tabs.TabPane tab="项目报表" key="7">
          <ProjectReport {...props} projectId={projectId} detailTitle={data.name}/>
        </Tabs.TabPane>
  
        {
          (roleCode !== 'EDC_AM' && roleCode !== 'DCT_JS_PM' )  && (
            <>
            <Tabs.TabPane tab="项目区域管理" key="4">
              <RegionalManagement projectId={projectId}/>
            </Tabs.TabPane>
            <Tabs.TabPane tab="项目研究中心" key="2" >
              <ResearchCenter projectId={projectId}/>
            </Tabs.TabPane>
            </>
          )
        }
        {
          roleCode !== 'DCT_JS_PM' && (
            <Tabs.TabPane tab="项目参与者" key="3">
              <Participants projectId={projectId}/>
            </Tabs.TabPane>
          )
        }
   
        {
          (roleCode !== 'EDC_AM' && roleCode !== 'DCT_JS_PM' )  && (
            <Fragment>
              <Tabs.TabPane tab="分组管理" key="8">
                <GroupManage projectId={projectId} projectCode={data.code}/>
              </Tabs.TabPane>
              <Tabs.TabPane tab="结算管理" key="5">
                <ProjectSettlement projectId={projectId} detailTitle={data.name} />
              </Tabs.TabPane>
              <Tabs.TabPane tab="项目设置" key="6">
                <Setting projectId={projectId} {...data} onSave={(key: string)=> setActiveKey(key)}/>
              </Tabs.TabPane>
            </Fragment>
          )
        }
        


      </Tabs>
    </div>
  )
}

export default ProjectDetail

